var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12",
        height: "11",
        viewBox: "0 0 12 11",
        fill: "none",
      },
    },
    [
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M4.98819 1.08381C5.25086 0.650762 5.71811 0.387695 6.22193 0.387695C6.72575 0.387695 7.193 0.650762 7.45567 1.08381L11.529 7.88406C11.7851 8.32756 11.7866 8.87366 11.533 9.31859C11.2794 9.76352 10.8088 10.0405 10.2914 10.0461H2.14721C1.6351 10.0405 1.16444 9.76352 0.91083 9.31859C0.657218 8.87366 0.658747 8.32756 0.918749 7.87742L4.98819 1.08381ZM1.74698 8.36457C1.66162 8.5124 1.66111 8.69443 1.74564 8.84274C1.83018 8.99106 1.98707 9.08337 2.15249 9.08525H10.2861C10.4568 9.08337 10.6137 8.99106 10.6982 8.84274C10.7828 8.69443 10.7822 8.5124 10.7008 8.3712L6.63272 1.57988C6.54562 1.43629 6.38987 1.3486 6.22193 1.3486C6.05436 1.3486 5.89892 1.43591 5.81172 1.57894L1.74698 8.36457Z",
          fill: "#F10519",
        },
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M5.74146 3.80052C5.74146 3.53517 5.95656 3.32007 6.22191 3.32007C6.48726 3.32007 6.70236 3.53517 6.70236 3.80052V5.72234C6.70236 5.98768 6.48726 6.20279 6.22191 6.20279C5.95656 6.20279 5.74146 5.98768 5.74146 5.72234V3.80052Z",
          fill: "#F10519",
        },
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d: "M6.22191 6.68286C6.48726 6.68286 6.70236 6.89797 6.70236 7.16331C6.70236 7.42866 6.48726 7.64377 6.22191 7.64377C5.95656 7.64377 5.74146 7.42866 5.74146 7.16331C5.74146 6.89797 5.95656 6.68286 6.22191 6.68286Z",
          fill: "#F10519",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }